{
  "chart": "रोगी चार्ट",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "जनसांख्यिकी",
    "loading": "रोगी जनसांख्यिकी लोड हो रही है...",
    "loadError": "रोगी जनसांख्यिकी लोड करने में विफल।",
    "returnToDashboard": "डैशबोर्ड पर लौटें",
    "updatedSuccess": "रोगी जनसांख्यिकी अद्यतन की गई",
    "updateError": "रोगी जनसांख्यिकी अद्यतन करने में विफल",
    "sections": {
      "personalInformation": "व्यक्तिगत जानकारी",
      "identification": "पहचान",
      "contactInformation": "संपर्क जानकारी",
      "address": "पता",
      "languageAndPreferences": "भाषा एवं प्राथमिकताएँ",
      "specialFlags": "विशेष ध्वज",
      "recordInformation": "रिकॉर्ड जानकारी"
    },
    "fields": {
      "fullName": "पूरा नाम",
      "alternativeName": "वैकल्पिक नाम",
      "preferredName": "पसंदीदा नाम",
      "dateOfBirth": "जन्म तिथि",
      "birthTime": "जन्म का समय",
      "age": "आयु",
      "legalGender": "वैधानिक लिंग",
      "genderIdentity": "लैंगिक पहचान",
      "sexAtBirth": "जन्म के समय लिंग",
      "race": "नस्ल",
      "ethnicity": "जातीयता",
      "nationality": "राष्ट्रीयता",
      "mrn": "MRN",
      "nationalIdType": "राष्ट्रीय पहचान प्रकार",
      "nationalIdNumber": "राष्ट्रीय पहचान संख्या",
      "passportNumber": "पासपोर्ट संख्या",
      "passportCountry": "पासपोर्ट जारीकर्ता देश",
      "primaryPhone": "मुख्य फ़ोन",
      "mobilePhone": "मोबाइल फ़ोन",
      "email": "ईमेल",
      "preferredContactMethod": "पसंदीदा संपर्क विधि",
      "addressLine1": "पता पंक्ति 1",
      "addressLine2": "पता पंक्ति 2",
      "city": "शहर",
      "stateProvince": "राज्य/प्रांत",
      "postalCode": "डाक कोड",
      "country": "देश",
      "primaryLanguage": "मुख्य भाषा",
      "secondaryLanguage": "द्वितीयक भाषा",
      "interpreterRequired": "दुभाषिया आवश्यक",
      "vipStatus": "VIP स्थिति",
      "confidentialityLevel": "गोपनीयता स्तर",
      "medicalTourist": "चिकित्सा पर्यटक",
      "homeCountry": "मूल देश",
      "status": "स्थिति",
      "deceased": "मृत",
      "created": "बनाया गया",
      "lastModified": "अंतिम संशोधित",
      "passportOnFile": "पासपोर्ट फ़ाइल में",
      "organDonorStatus": "अंगदान स्थिति"
    },
    "statusValues": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "deceasedSummary": "हाँ ({{date}})",
    "deceasedDateUnknown": "तिथि अज्ञात",
    "legalGender": {
      "label": "वैधानिक लिंग",
      "values": {
        "male": "पुरुष",
        "female": "महिला",
        "other": "अन्य",
        "unknown": "अज्ञात"
      },
      "selectPlaceholder": "लिंग चुनें"
    },
    "sexAtBirth": {
      "label": "जन्म के समय लिंग",
      "values": {
        "female": "महिला",
        "male": "पुरुष",
        "other": "अन्य",
        "unknown": "अज्ञात"
      },
      "notRecorded": "दर्ज नहीं"
    },
    "preferredContactMethod": {
      "label": "पसंदीदा संपर्क विधि",
      "values": {
        "phone": "फ़ोन",
        "mobile": "मोबाइल",
        "email": "ईमेल",
        "sms": "SMS"
      },
      "notSpecified": "निर्दिष्ट नहीं"
    },
    "validation": {
      "fullNameRequired": "पूरा नाम आवश्यक है",
      "dateOfBirthRequired": "जन्म तिथि आवश्यक है",
      "countryRequired": "देश आवश्यक है",
      "primaryLanguageRequired": "मुख्य भाषा आवश्यक है",
      "invalidEmail": "अमान्य ईमेल",
      "nationalIdValidationFailed": "राष्ट्रीय पहचान सत्यापन विफल: {{error}}",
      "invalidBirthTime": "जन्म का समय HH:MM प्रारूप में होना चाहिए"
    },
    "organDonor": {
      "notRecorded": "दर्ज नहीं",
      "registered": "पंजीकृत दाता",
      "optedOut": "अस्वीकृत",
      "notRegistered": "पंजीकृत नहीं",
      "unknown": "अज्ञात"
    }
  },
  "registration": {
    "title": "रोगी पंजीकरण",
    "subtitle": "सिस्टम में नए रोगी का पंजीकरण करें",
    "submit": "रोगी पंजीकरण करें",
    "submitting": "पंजीकरण हो रहा है...",
    "checkingDuplicates": "डुप्लिकेट की जाँच हो रही है...",
    "registerNew": "नया रोगी पंजीकरण",
    "registeredSuccess": "रोगी सफलतापूर्वक पंजीकृत हो गया",
    "registerError": "रोगी पंजीकरण में विफल",
    "validationNationalIdFailed": "राष्ट्रीय पहचान सत्यापन विफल: {{error}}",
    "sections": {
      "basicInformation": "बुनियादी जानकारी",
      "identification": "पहचान",
      "contactInformation": "संपर्क जानकारी",
      "address": "पता",
      "languageAndCommunication": "भाषा एवं संवाद",
      "additionalInformation": "अतिरिक्त जानकारी"
    },
    "fields": {
      "facility": "पंजीकरण सुविधा"
    },
    "placeholders": {
      "fullName": "उदा. राज शर्मा या 李小明",
      "alternativeName": "उपलब्ध हो तो रोमन लिपि",
      "preferredName": "जिस नाम से रोगी बुलाया जाना पसंद करता है",
      "nationalIdNumberDefault": "राष्ट्रीय पहचान संख्या दर्ज करें",
      "primaryPhone": "+91 98765 43210",
      "mobilePhone": "+91 98765 43210",
      "email": "patient@example.com",
      "facility": "सुविधा चुनें"
    },
    "helperText": {
      "fullName": "आधिकारिक दस्तावेज़ों के अनुसार रोगी का पूरा नाम दर्ज करें",
      "facility": "वह सुविधा जहाँ यह रोगी पंजीकृत किया जा रहा है। वहाँ के कर्मचारी यह रिकॉर्ड खोल सकेंगे।"
    },
    "flags": {
      "vipPatient": "VIP रोगी",
      "medicalTourist": "चिकित्सा पर्यटक"
    },
    "duplicate": {
      "title": "संभावित डुप्लिकेट रोगी मिले",
      "body": "निम्नलिखित मौजूदा रोगी आपके द्वारा दर्ज जानकारी से मेल खाते हैं:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "मिलान: {{score}}% ({{reasons}})",
      "useExisting": "मौजूदा का उपयोग करें",
      "createNew": "यह एक नया रोगी है",
      "restricted": {
        "title_one": "{{count}} संभावित मिलान मौजूद है जिसे आप नहीं देख सकते",
        "title_other": "{{count}} संभावित मिलान मौजूद हैं जिन्हें आप नहीं देख सकते",
        "body": "इस रोगी का रिकॉर्ड किसी अन्य सुविधा में पहले से हो सकता है। नया रिकॉर्ड बनाने से पहले स्वास्थ्य सूचना प्रबंधन से संपर्क करें — विवरण छिपाए गए हैं क्योंकि वह रिकॉर्ड आपकी पहुँच से बाहर है।"
      },
      "overrideReasonLabel": "फिर भी पंजीकृत करने का कारण",
      "overrideReasonPlaceholder": "उदा. रोगी से पुष्टि की कि यह अलग व्यक्ति है",
      "overrideReasonHelp": "आपके खाते के विरुद्ध दर्ज किया जाएगा। एक ही व्यक्ति के लिए दूसरा रिकॉर्ड बनाने से उनका चार्ट बँट जाता है।",
      "registerAnyway": "फिर भी पंजीकृत करें"
    }
  },
  "search": {
    "title": "रोगी खोज",
    "subtitle": "रोगी रिकॉर्ड खोजें और प्रबंधित करें",
    "placeholder": "रोगी के नाम, MRN या ID से खोजें...",
    "advancedFilters": "उन्नत फ़िल्टर",
    "filters": {
      "mrnPlaceholder": "उदा. P0000000001",
      "fullNamePlaceholder": "रोगी का नाम",
      "phonePlaceholder": "फ़ोन नंबर",
      "emailPlaceholder": "ईमेल पता"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "पूरा नाम",
      "dateOfBirth": "जन्म तिथि",
      "phone": "फ़ोन",
      "email": "ईमेल",
      "country": "देश",
      "status": "स्थिति",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "सभी",
      "vipOnly": "केवल VIP",
      "nonVipOnly": "केवल गैर-VIP"
    },
    "statusFilter": {
      "all": "सभी",
      "active": "सक्रिय",
      "inactive": "निष्क्रिय"
    },
    "countryFilter": {
      "all": "सभी देश"
    },
    "clearFilters": "फ़िल्टर साफ़ करें",
    "dateOfBirthAria": "जन्म तिथि फ़िल्टर",
    "columns": {
      "mrn": "MRN",
      "fullName": "पूरा नाम",
      "dob": "DOB",
      "gender": "लिंग",
      "phone": "फ़ोन",
      "country": "देश",
      "status": "स्थिति"
    },
    "results": {
      "searching": "रोगी खोजे जा रहे हैं...",
      "loadError": "रोगियों को लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "retry": "पुनः प्रयास करें",
      "empty": "कोई रोगी नहीं मिला। कृपया अपने खोज मानदंड समायोजित करें।",
      "showing": "{{total}} रोगियों में से {{from}}–{{to}} दिखाए जा रहे हैं"
    }
  },
  "myPatients": {
    "title": "मेरे रोगी",
    "subtitle": "आपकी देखभाल में सक्रिय रोगी",
    "searchPlaceholder": "नाम या MRN से छाँटें...",
    "columns": {
      "mrn": "MRN",
      "patient": "पूरा नाम",
      "dob": "DOB",
      "sex": "लिंग",
      "class": "श्रेणी",
      "relationship": "संबंध",
      "admitted": "भर्ती तिथि"
    },
    "kind": {
      "attending": "उपस्थित",
      "careTeam": "देखभाल दल",
      "referral": "रेफरल",
      "coverage": "कवरेज"
    },
    "restrictedBadge": "प्रतिबंधित",
    "empty": {
      "title": "आपके पैनल में कोई रोगी नहीं",
      "body": "जिन रोगियों का आप उपचार करते हैं, कवर करते हैं या रेफरल से प्राप्त करते हैं, वे यहाँ दिखेंगे।",
      "censusAction": "बेड बोर्ड खोलें"
    },
    "results": {
      "searching": "अपने रोगी लोड हो रहे हैं...",
      "loadError": "आपके रोगियों को लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "retry": "पुनः प्रयास करें",
      "showing": "{{total}} रोगियों में से {{from}}–{{to}} दिखाए जा रहे हैं"
    }
  },
  "encounters": {
    "title": "मुलाकातें",
    "create": "मुलाकात बनाएँ",
    "filters": "फ़िल्टर",
    "filterLabels": {
      "status": "स्थिति",
      "class": "श्रेणी",
      "fromDate": "तिथि से",
      "toDate": "तिथि तक"
    },
    "filterPlaceholders": {
      "allStatuses": "सभी स्थितियाँ",
      "allClasses": "सभी श्रेणियाँ"
    },
    "clearFilters": "फ़िल्टर साफ़ करें",
    "fromDateAria": "तिथि से",
    "toDateAria": "तिथि तक",
    "columns": {
      "encounterNumber": "मुलाकात क्र.",
      "class": "श्रेणी",
      "status": "स्थिति",
      "admitDate": "प्रवेश तिथि",
      "dischargeDate": "छुट्टी तिथि",
      "location": "स्थान",
      "chiefComplaint": "मुख्य शिकायत"
    },
    "locationLabel": "स्थान #{{id}}",
    "loading": "मुलाकातें लोड हो रही हैं...",
    "loadError": "मुलाकातें लोड करने में विफल।",
    "empty": "इस रोगी के लिए कोई मुलाकात नहीं मिली।",
    "showing": "{{total}} में से {{from}}–{{to}} दिखाए जा रहे हैं"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "राष्ट्रीय पहचान प्रकार",
      "none": "कोई नहीं",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "आधार",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "थाई राष्ट्रीय पहचान पत्र"
      },
      "country": {
        "nric": "सिंगापुर",
        "hkid": "हांगकांग",
        "myKad": "मलेशिया",
        "aadhaar": "भारत",
        "ktp": "इंडोनेशिया",
        "myNumber": "जापान",
        "thaiNationalId": "थाईलैंड"
      },
      "placeholderByType": {
        "nric": "उदा. S1234567D",
        "myKad": "उदा. 850101-14-5678",
        "hkid": "उदा. A123456(3)",
        "aadhaar": "उदा. 2341 2341 2346",
        "thaiNationalId": "उदा. 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "इस पहचान प्रकार के लिए जाँच वर्ण मेल नहीं खाता। मरीज़ के पहचान दस्तावेज़ से नंबर का मिलान करें।",
      "unavailable": "इस पहचान नंबर की जाँच नहीं हो सकी। मरीज़ के पहचान दस्तावेज़ से नंबर का मिलान करें।",
      "acknowledge": "मैंने पहचान दस्तावेज़ से इस नंबर का मिलान कर लिया है",
      "acknowledgeRequired": "सहेजने से पहले पहचान दस्तावेज़ से पहचान नंबर का मिलान करें और पुष्टि करें।"
    }
  },
  "country": {
    "values": {
      "sg": "सिंगापुर",
      "my": "मलेशिया",
      "th": "थाईलैंड",
      "id": "इंडोनेशिया",
      "ph": "फिलीपींस",
      "vn": "वियतनाम",
      "hk": "हांगकांग",
      "tw": "ताइवान",
      "jp": "जापान",
      "kr": "दक्षिण कोरिया",
      "cn": "चीन",
      "in": "भारत",
      "au": "ऑस्ट्रेलिया",
      "nz": "न्यूज़ीलैंड"
    }
  },
  "language": {
    "values": {
      "en": "अंग्रेज़ी",
      "zh": "चीनी (मंदारिन)",
      "ms": "मलय",
      "ta": "तमिल",
      "th": "थाई",
      "id": "इंडोनेशियाई",
      "vi": "वियतनामी",
      "ja": "जापानी",
      "ko": "कोरियाई",
      "hi": "हिंदी"
    }
  },
  "contact": {
    "addTitle": "संपर्क जोड़ें",
    "editTitle": "संपर्क संपादित करें",
    "name": "नाम",
    "relationship": {
      "label": "रिश्ता",
      "selectPlaceholder": "चुनें...",
      "values": {
        "spouse": "जीवनसाथी",
        "parent": "माता-पिता",
        "child": "संतान",
        "sibling": "भाई-बहन",
        "guardian": "अभिभावक",
        "friend": "मित्र",
        "other": "अन्य"
      }
    },
    "phone": "फ़ोन",
    "email": "ईमेल",
    "emergencyContact": "आपातकालीन संपर्क",
    "validation": {
      "nameRequired": "संपर्क का नाम आवश्यक है",
      "relationshipRequired": "रिश्ता आवश्यक है",
      "phoneRequired": "फ़ोन नंबर आवश्यक है",
      "invalidEmail": "अमान्य ईमेल"
    },
    "savedSuccess": "संपर्क सफलतापूर्वक जोड़ा गया",
    "saveError": "संपर्क जोड़ने में विफल"
  },
  "immunization": {
    "addTitle": "टीकाकरण जोड़ें",
    "vaccineName": "टीके का नाम",
    "vaccineNamePlaceholder": "जैसे, इन्फ्लूएंजा, COVID-19 (Pfizer), हेपेटाइटिस B",
    "vaccineCode": "टीका कोड (CVX)",
    "vaccineCodePlaceholder": "जैसे, 141",
    "administeredDate": "टीकाकरण की तिथि",
    "lotNumber": "लॉट संख्या",
    "lotNumberPlaceholder": "जैसे, AB1234",
    "site": {
      "label": "स्थान",
      "selectPlaceholder": "स्थान चुनें",
      "values": {
        "leftDeltoid": "बायाँ डेल्टॉइड",
        "rightDeltoid": "दायाँ डेल्टॉइड",
        "leftThigh": "बायीं जांघ",
        "rightThigh": "दायीं जांघ",
        "leftGluteal": "बायाँ नितंब",
        "rightGluteal": "दायाँ नितंब",
        "other": "अन्य"
      }
    },
    "route": {
      "label": "मार्ग",
      "selectPlaceholder": "मार्ग चुनें",
      "values": {
        "intramuscular": "इंट्रामस्क्युलर (IM)",
        "subcutaneous": "सबक्यूटेनियस (SC)",
        "intradermal": "इंट्राडर्मल (ID)",
        "oral": "मौखिक",
        "intranasal": "नासिका"
      }
    },
    "doseAmount": "खुराक",
    "doseAmountPlaceholder": "जैसे, 0.5 mL",
    "administeredBy": "टीकाकर्ता",
    "administeredByPlaceholder": "स्वास्थ्यकर्मी का नाम या ID",
    "nextDueDate": "अगली खुराक की तिथि",
    "notes": "टिप्पणियाँ",
    "notesPlaceholder": "अतिरिक्त टिप्पणियाँ...",
    "validation": {
      "vaccineNameRequired": "टीके का नाम आवश्यक है",
      "administeredDateRequired": "टीकाकरण की तिथि आवश्यक है"
    },
    "savedSuccess": "टीकाकरण रिकॉर्ड जोड़ा गया",
    "saveError": "टीकाकरण रिकॉर्ड जोड़ने में विफल"
  },
  "insurance": {
    "addTitle": "बीमा योजना जोड़ें",
    "submitLabel": "बीमा जोड़ें",
    "payerName": "भुगतानकर्ता का नाम",
    "payerNamePlaceholder": "जैसे, AIA सिंगापुर",
    "payerId": "भुगतानकर्ता ID",
    "payerIdPlaceholder": "भुगतानकर्ता पहचानकर्ता",
    "planName": "योजना का नाम",
    "planNamePlaceholder": "जैसे, HealthShield Gold Max",
    "planType": {
      "label": "योजना प्रकार",
      "selectPlaceholder": "प्रकार चुनें",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "सरकारी",
        "private": "निजी",
        "corporate": "कॉर्पोरेट",
        "other": "अन्य"
      }
    },
    "memberId": "सदस्य ID",
    "memberIdPlaceholder": "सदस्य ID संख्या",
    "policyNumber": "पॉलिसी नंबर",
    "policyNumberPlaceholder": "पॉलिसी नंबर दर्ज करें",
    "groupNumber": "समूह संख्या",
    "groupNumberPlaceholder": "समूह संख्या",
    "subscriberName": "ग्राहक का नाम",
    "subscriberNamePlaceholder": "यदि रोगी से भिन्न हो",
    "subscriberRelationship": {
      "label": "ग्राहक से रिश्ता",
      "values": {
        "self": "स्वयं",
        "spouse": "जीवनसाथी",
        "child": "संतान",
        "parent": "माता-पिता",
        "other": "अन्य"
      }
    },
    "priority": {
      "label": "प्राथमिकता",
      "values": {
        "primary": "प्राथमिक",
        "secondary": "द्वितीयक",
        "tertiary": "तृतीयक"
      }
    },
    "effectiveDate": "प्रभावी तिथि",
    "terminationDate": "समाप्ति तिथि",
    "copayAmount": "सह-भुगतान राशि ($)",
    "coinsurancePercent": "सह-बीमा (%)",
    "deductibleAmount": "कटौती योग्य ($)",
    "outOfPocketMax": "अधिकतम स्व-व्यय ($)",
    "preAuthRequired": "पूर्व-अनुमोदन आवश्यक",
    "notes": "टिप्पणियाँ",
    "notesPlaceholder": "अतिरिक्त टिप्पणियाँ...",
    "validation": {
      "payerNameRequired": "भुगतानकर्ता का नाम आवश्यक है",
      "planNameRequired": "योजना का नाम आवश्यक है",
      "memberIdRequired": "सदस्य ID आवश्यक है",
      "effectiveDateRequired": "प्रभावी तिथि आवश्यक है"
    },
    "savedSuccess": "बीमा योजना जोड़ी गई",
    "saveError": "बीमा योजना जोड़ने में विफल"
  },
  "problem": {
    "addTitle": "समस्या जोड़ें",
    "problemName": "समस्या का नाम",
    "problemNamePlaceholder": "जैसे, टाइप 2 मधुमेह मेलिटस",
    "icdCode": "ICD-10 कोड",
    "icdSearchPlaceholder": "ICD-10 कोड या विवरण खोजें...",
    "onsetDate": "आरंभ तिथि",
    "severity": {
      "label": "गंभीरता",
      "values": {
        "mild": "हल्की",
        "moderate": "मध्यम",
        "severe": "गंभीर"
      }
    },
    "notes": "टिप्पणियाँ",
    "notesPlaceholder": "अतिरिक्त नैदानिक टिप्पणियाँ...",
    "validation": {
      "problemNameRequired": "समस्या का नाम आवश्यक है"
    },
    "savedSuccess": "समस्या सूची में जोड़ी गई",
    "saveError": "समस्या जोड़ने में विफल"
  },
  "accounts": {
    "pageTitle": "रोगी खाते",
    "backToDashboard": "डैशबोर्ड",
    "searchPatientLabel": "रोगी खोजें",
    "searchPlaceholder": "नाम या MRN द्वारा खोजें...",
    "searching": "खोज रहा है...",
    "noPatientsFound": "कोई रोगी नहीं मिला",
    "loadingAccount": "खाता लोड हो रहा है...",
    "mrnLabel": "MRN",
    "generateStatement": "विवरण उत्पन्न करें",
    "statementComingSoon": "विवरण उत्पन्न करने की सुविधा शीघ्र आ रही है",
    "paymentPlan": "भुगतान योजना",
    "paymentPlanComingSoon": "भुगतान योजना सेटअप शीघ्र आ रहा है",
    "totalCharges": "कुल शुल्क",
    "totalPayments": "कुल भुगतान",
    "adjustments": "समायोजन",
    "outstandingBalance": "बकाया शेष",
    "transactionHistory": "लेन-देन इतिहास",
    "columns": {
      "date": "तिथि",
      "type": "प्रकार",
      "description": "विवरण",
      "amount": "राशि",
      "balance": "शेष"
    },
    "transactionType": {
      "label": "प्रकार",
      "values": {
        "charge": "शुल्क",
        "payment": "भुगतान",
        "adjustment": "समायोजन"
      }
    },
    "loadingTransactions": "लेन-देन लोड हो रहे हैं...",
    "noTransactionsFound": "कोई लेन-देन नहीं मिला",
    "emptyState": "उनके खाते को देखने के लिए रोगी खोजें"
  },
  "proxies": {
    "title": "अधिकृत प्रतिनिधि",
    "description": "देखभाल करने वाले, अभिभावक और कानूनी प्रतिनिधि जो इस रोगी के पोर्टल डेटा तक पहुँचने के लिए अधिकृत हैं। निरस्त प्रविष्टियाँ ऑडिट के लिए रखी जाती हैं।",
    "addProxy": "प्रतिनिधि जोड़ें",
    "newRelationshipHeading": "नया प्रतिनिधि संबंध",
    "proxyUserId": "प्रतिनिधि उपयोगकर्ता ID",
    "proxyUserIdPlaceholder": "उपयोगकर्ता ID (व्यवस्थापन → उपयोगकर्ता से)",
    "proxyUserIdHelper": "व्यवस्थापन → उपयोगकर्ता में देखें। उपयोगकर्ता-चयनकर्ता घटक अगले अद्यतन में आएगा।",
    "relationship": {
      "label": "रिश्ता",
      "values": {
        "parent": "माता-पिता",
        "legalGuardian": "कानूनी अभिभावक",
        "spousePartner": "जीवनसाथी / साथी",
        "adultChild": "वयस्क संतान",
        "powerOfAttorney": "मुख्तार",
        "healthcareAgent": "स्वास्थ्य प्रतिनिधि"
      }
    },
    "accessLevel": {
      "label": "पहुँच स्तर",
      "values": {
        "full": "पूर्ण",
        "limited": "सीमित",
        "emergency": "आपातकालीन"
      },
      "descriptions": {
        "full": "सभी पोर्टल डेटा — अपॉइंटमेंट, परिणाम, संदेश, फ़ॉर्म।",
        "limited": "केवल अपॉइंटमेंट और संदेश (किशोरों के लिए सामान्य)।",
        "emergency": "रोगी के असमर्थ होने पर स्वास्थ्य प्रतिनिधि के लिए break-glass समकक्ष।"
      }
    },
    "startDate": "आरंभ तिथि",
    "endDate": "समाप्ति तिथि",
    "startDateAria": "प्रभावी आरंभ तिथि",
    "endDateAria": "प्रभावी समाप्ति तिथि",
    "grantAccess": "प्रतिनिधि पहुँच प्रदान करें",
    "userIdRequired": "प्रतिनिधि उपयोगकर्ता ID आवश्यक है",
    "createdSuccess": "प्रतिनिधि संबंध बनाया गया",
    "duplicateError": "यह व्यक्ति पहले से ही उसी संबंध में प्रतिनिधि है",
    "invalidDataError": "प्रतिनिधि डेटा अमान्य है",
    "createError": "प्रतिनिधि बनाने में विफल",
    "revokedSuccess": "प्रतिनिधि पहुँच निरस्त की गई",
    "revokeError": "प्रतिनिधि निरस्त करने में विफल",
    "emptyState": "कोई प्रतिनिधि कॉन्फ़िगर नहीं किया गया। ऊपर दिए गए बटन से देखभाल करने वाले, अभिभावक या स्वास्थ्य प्रतिनिधि को पहुँच प्रदान करें।",
    "sections": {
      "active": "सक्रिय ({{count}})",
      "plannedInactive": "नियोजित / निष्क्रिय ({{count}})",
      "revoked": "निरस्त ({{count}})"
    },
    "userIdFallback": "उपयोगकर्ता #{{id}}",
    "noEndDate": "(कोई समाप्ति तिथि नहीं)",
    "revokedOn": "{{date}} को निरस्त",
    "revokeTitle": "प्रतिनिधि पहुँच निरस्त करें",
    "confirmRevokeTitle": "प्रतिनिधि पहुँच निरस्त करें?",
    "confirmRevokeBody": "{{name}} तुरंत इस रोगी के पोर्टल डेटा तक पहुँच खो देगा। रिकॉर्ड ऑडिट ट्रेल में बना रहेगा।",
    "confirmRevokeLabel": "पहुँच निरस्त करें"
  },
  "merge": {
    "title": "रोगी विलय",
    "description": "डुप्लिकेट रोगी रिकॉर्ड को मर्ज करें। स्रोत रोगी निष्क्रिय कर दिया जाएगा और सभी नैदानिक डेटा लक्ष्य (शेष) रोगी में स्थानांतरित कर दिया जाएगा।",
    "sourceLabel": "स्रोत रोगी (निष्क्रिय कर दिया जाएगा)",
    "targetLabel": "लक्ष्य रोगी (शेष रिकॉर्ड)",
    "clearSelection": "चयन साफ़ करें",
    "searchPlaceholder": "नाम, MRN या फ़ोन से खोजें...",
    "fields": {
      "mrn": "MRN",
      "dob": "जन्म तिथि",
      "gender": "लिंग",
      "country": "देश",
      "phone": "फ़ोन",
      "email": "ईमेल"
    },
    "counts": {
      "encounters": "मुलाक़ातें: {{count}}",
      "allergies": "एलर्जी: {{count}}",
      "problems": "समस्याएँ: {{count}}"
    },
    "samePatientWarning": "स्रोत और लक्ष्य अलग-अलग रोगी होने चाहिए।",
    "comparisonTitle": "जनसांख्यिकी तुलना",
    "comparisonSubtitle": "अंतर अंबर रंग में हाइलाइट किए गए हैं।",
    "columns": {
      "field": "फ़ील्ड",
      "source": "स्रोत ({{mrn}})",
      "target": "लक्ष्य ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "पूरा नाम",
      "mrn": "MRN",
      "dateOfBirth": "जन्म तिथि",
      "gender": "लिंग",
      "phone": "फ़ोन",
      "email": "ईमेल",
      "country": "देश",
      "nationalId": "राष्ट्रीय ID"
    },
    "reasonLabel": "विलय का कारण",
    "reasonPlaceholder": "इन रिकॉर्ड्स को मर्ज करने का कारण (आवश्यक)",
    "notesLabel": "टिप्पणियाँ (वैकल्पिक)",
    "notesPlaceholder": "इस विलय के बारे में अतिरिक्त टिप्पणियाँ",
    "mergeButton": "रोगियों को मर्ज करें",
    "mergeSuccess": "रोगी सफलतापूर्वक मर्ज किए गए",
    "mergeError": "रोगी मर्ज करने में विफल",
    "successHeading": "विलय सफलतापूर्वक पूरा हुआ।",
    "successBodyPrefix": "रोगी {{mrn}} को निष्क्रिय कर दिया गया है। सभी नैदानिक डेटा को ",
    "successBodySuffix": " में स्थानांतरित कर दिया गया है।",
    "confirmTitle": "रोगी विलय की पुष्टि करें",
    "confirmBodyPrefix": "यह क्रिया ",
    "confirmBodyEmphasis": "पूर्ववत नहीं की जा सकती",
    "confirmBodySuffix": "। रोगी {{sourceMrn}} ({{sourceName}}) को निष्क्रिय कर दिया जाएगा और सभी नैदानिक डेटा रोगी {{targetMrn}} ({{targetName}}) में स्थानांतरित कर दिया जाएगा।",
    "confirmButton": "हाँ, रोगियों को मर्ज करें",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "रोगी रिकॉर्ड लोड नहीं हो सका।"
  },
  "allergy": {
    "addTitle": "एलर्जी जोड़ें",
    "editTitle": "एलर्जी संपादित करें",
    "allergen": "एलर्जेन",
    "allergenPlaceholder": "उदा. पेनिसिलिन, मूंगफली",
    "type": "प्रकार",
    "typeOptions": {
      "drug": "औषधि",
      "food": "भोजन",
      "environmental": "पर्यावरणीय"
    },
    "severityLabel": "गंभीरता",
    "severity": {
      "mild": "हल्की",
      "moderate": "मध्यम",
      "severe": "गंभीर",
      "lifeThreatening": "जानलेवा"
    },
    "reaction": "प्रतिक्रिया",
    "reactionPlaceholder": "उदा. पित्ती, तीव्रग्राहिता, मतली",
    "reactionOptions": {
      "rash": "चकत्ता",
      "hives": "पित्ती",
      "anaphylaxis": "तीव्रग्राहिता",
      "swelling": "सूजन",
      "itching": "खुजली",
      "other": "अन्य"
    },
    "onsetDate": "प्रारंभ तिथि",
    "notes": "टिप्पणियाँ",
    "notesPlaceholder": "अतिरिक्त टिप्पणियाँ...",
    "verifiedBy": "सत्यापनकर्ता",
    "noKnownAllergies": "कोई ज्ञात एलर्जी नहीं",
    "savedSuccess": "एलर्जी सफलतापूर्वक जोड़ी गई",
    "saveError": "एलर्जी जोड़ने में विफल",
    "deletedSuccess": "एलर्जी हटा दी गई"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "ब्रेडन स्केल (दबाव चोट जोखिम)",
      "footer": "कुल सीमा: 6-23। कम स्कोर दबाव चोट विकास के उच्च जोखिम का संकेत देता है।",
      "scoreFormat": "स्कोर: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "बहुत उच्च जोखिम",
        "high": "उच्च जोखिम",
        "moderate": "मध्यम जोखिम",
        "mild": "हल्का जोखिम",
        "none": "कोई जोखिम नहीं"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. संवेदी अनुभूति",
          "options": {
            "1": "{{n}} - पूर्ण रूप से सीमित",
            "2": "{{n}} - बहुत सीमित",
            "3": "{{n}} - थोड़ा सीमित",
            "4": "{{n}} - कोई हानि नहीं"
          }
        },
        "moisture": {
          "label": "{{n}}. नमी",
          "options": {
            "1": "{{n}} - लगातार नम",
            "2": "{{n}} - बहुत नम",
            "3": "{{n}} - कभी-कभी नम",
            "4": "{{n}} - शायद ही कभी नम"
          }
        },
        "activity": {
          "label": "{{n}}. गतिविधि",
          "options": {
            "1": "{{n}} - बिस्तर पर",
            "2": "{{n}} - कुर्सी तक सीमित",
            "3": "{{n}} - कभी-कभी चलते हैं",
            "4": "{{n}} - बार-बार चलते हैं"
          }
        },
        "mobility": {
          "label": "{{n}}. गतिशीलता",
          "options": {
            "1": "{{n}} - पूर्णतः अचल",
            "2": "{{n}} - बहुत सीमित",
            "3": "{{n}} - थोड़ा सीमित",
            "4": "{{n}} - कोई सीमा नहीं"
          }
        },
        "nutrition": {
          "label": "{{n}}. पोषण",
          "options": {
            "1": "{{n}} - बहुत खराब",
            "2": "{{n}} - संभवतः अपर्याप्त",
            "3": "{{n}} - पर्याप्त",
            "4": "{{n}} - उत्कृष्ट"
          }
        },
        "frictionShear": {
          "label": "{{n}}. घर्षण और कतरनी",
          "options": {
            "1": "{{n}} - समस्या",
            "2": "{{n}} - संभावित समस्या",
            "3": "{{n}} - कोई स्पष्ट समस्या नहीं"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "मोर्स फॉल स्केल",
      "scoreFormat": "स्कोर: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. गिरने का इतिहास",
          "options": {
            "0": "नहीं ({{score}})",
            "25": "हाँ ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. द्वितीयक निदान",
          "options": {
            "0": "नहीं ({{score}})",
            "15": "हाँ ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. चलने का सहायक",
          "options": {
            "0": "कोई नहीं / बिस्तर पर आराम / नर्स की सहायता ({{score}})",
            "15": "बैसाखी / छड़ी / वॉकर ({{score}})",
            "30": "फर्नीचर का सहारा ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. IV / हेपरिन लॉक",
          "options": {
            "0": "नहीं ({{score}})",
            "20": "हाँ ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. चाल",
          "options": {
            "0": "सामान्य / बिस्तर पर आराम / व्हीलचेयर ({{score}})",
            "10": "कमज़ोर ({{score}})",
            "20": "क्षीण ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. मानसिक स्थिति",
          "options": {
            "0": "अपनी क्षमता के प्रति जागरूक ({{score}})",
            "15": "अति-आकलन / सीमाओं को भूलना ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "उच्च जोखिम हस्तक्षेप: मानक गिरने की रोकथाम लागू करें। रोगी पर गिरने का जोखिम कलाई बंध लगाएं। बिस्तर के पास गिरने का जोखिम चिन्ह लगाएं। रोगी और परिवार को शिक्षित करें। बिस्तर को सबसे निचली स्थिति में रखें और ब्रेक लॉक करें। सुनिश्चित करें कि कॉल लाइट पहुंच के भीतर हो। नॉन-स्किड फुटवियर। शौचालय कार्यक्रम। आवश्यकता हो तो 1:1 निगरानी पर विचार करें।",
        "moderate": "मध्यम जोखिम हस्तक्षेप: मानक गिरने की रोकथाम लागू करें। रोगी पर गिरने का जोखिम कलाई बंध लगाएं। रोगी और परिवार को शिक्षित करें। बिस्तर को सबसे निचली स्थिति में रखें और ब्रेक लॉक करें। सुनिश्चित करें कि कॉल लाइट पहुंच के भीतर हो। नॉन-स्किड फुटवियर।",
        "low": "कम जोखिम हस्तक्षेप: अच्छी बुनियादी नर्सिंग देखभाल। रोगी को सुरक्षित गतिशीलता पर शिक्षित करें। पर्यावरण और कॉल लाइट के उपयोग का परिचय दें।"
      }
    }
  },
  "banner": {
    "label": "रोगी की जानकारी",
    "vip": "VIP",
    "vipTitle": "VIP रोगी",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "व",
    "sex": "लिंग",
    "codeStatusAria": "कोड स्थिति: {{status}}",
    "isolationAria": "आइसोलेशन: {{status}}",
    "isolation": {
      "contact": "संपर्क",
      "droplet": "बूँद",
      "airborne": "वायुजनित",
      "none": "कोई नहीं"
    },
    "fallRiskAria": "गिरने का जोखिम: {{level}}",
    "fallRisk": {
      "label": "गिरने का जोखिम",
      "low": "कम",
      "moderate": "मध्यम",
      "high": "उच्च"
    },
    "pressureInjuryRisk": "दबाव चोट जोखिम",
    "pressureInjuryRiskAria": "दबाव चोट जोखिम: {{level}}",
    "interpreter": "दुभाषिया",
    "interpreterRequired": "दुभाषिया आवश्यक — {{language}}",
    "languageNotSpecified": "भाषा निर्दिष्ट नहीं",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "एलर्जी",
    "moreAllergies_one": "+{{count}} और",
    "moreAllergies_other": "+{{count}} और",
    "nkda": "NKDA",
    "allergiesUnknown": "एलर्जी अज्ञात — लोड विफल"
  },
  "chartFrame": {
    "navAriaLabel": "रोगी चार्ट नेविगेशन",
    "tabs": {
      "summary": "सारांश",
      "encounters": "मुलाकातें",
      "orders": "आदेश",
      "results": "परिणाम",
      "medications": "दवाएँ",
      "notes": "नोट्स",
      "problems": "समस्या सूची",
      "allergies": "एलर्जी",
      "immunizations": "टीकाकरण",
      "intakeOutput": "सेवन/उत्सर्जन",
      "carePlans": "देखभाल योजनाएँ",
      "referrals": "रेफरल",
      "familyHistory": "पारिवारिक इतिहास",
      "socialHistory": "सामाजिक इतिहास",
      "surgicalHistory": "शल्य इतिहास",
      "advanceDirectives": "अग्रिम निर्देश",
      "insurance": "बीमा",
      "contacts": "संपर्क",
      "proxies": "प्रॉक्सी",
      "identifiers": "पहचानकर्ता",
      "addresses": "पते",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "युक्तियाँ",
      "ccdaImports": "C-CDA आयात"
    },
    "groups": {
      "clinical": "नैदानिक",
      "history": "इतिहास",
      "admin": "प्रशासन"
    },
    "breakGlass": {
      "auditBanner": "ब्रेक-ग्लास एक्सेस — सभी गतिविधियों का ऑडिट किया जा रहा है। एक्सेस 15 मिनट में समाप्त हो जाएगा।",
      "dialogTitle": "प्रतिबंधित रोगी रिकॉर्ड",
      "dialogSubtitle": "ब्रेक-ग्लास एक्सेस आवश्यक है",
      "dialogBody": "यह रोगी रिकॉर्ड प्रतिबंधित है। आपको इसे एक्सेस करने के लिए औचित्य प्रदान करना होगा। सभी ब्रेक-ग्लास एक्सेस लॉग और ऑडिट किए जाते हैं।",
      "justificationLabel": "औचित्य",
      "justificationPlaceholder": "इस प्रतिबंधित रिकॉर्ड को एक्सेस करने का नैदानिक औचित्य दर्ज करें...",
      "justificationRequired": "ब्रेक-ग्लास एक्सेस के लिए औचित्य आवश्यक है।",
      "requestError": "ब्रेक-ग्लास एक्सेस अनुरोध विफल। कृपया पुनः प्रयास करें या व्यवस्थापक से संपर्क करें।",
      "submitButton": "रिकॉर्ड एक्सेस करें",
      "submitting": "अनुरोध भेजा जा रहा है...",
      "passwordLabel": "अपना पासवर्ड पुष्टि करें",
      "passwordPlaceholder": "अपना पासवर्ड पुनः दर्ज करें",
      "passwordRequired": "आपातकालीन पहुँच के लिए आपका पासवर्ड आवश्यक है।",
      "passwordIncorrect": "गलत पासवर्ड। कृपया पुनः प्रयास करें।",
      "passwordHelp": "पुष्टि करता है कि इस वर्कस्टेशन पर आप ही हैं।",
      "totpLabel": "प्रमाणक कोड",
      "totpPlaceholder": "6-अंकीय कोड",
      "totpRequired": "आपातकालीन पहुच के लिए आपका प्रमाणक कोड आवश्यक है।",
      "totpIncorrect": "गलत कोड। कृपया पुनः प्रयास करें।",
      "totpHelp": "पुष्टि करता है कि इस वर्कस्टेशन पर आप ही हैं।",
      "totpEnrollHint": "कोई प्रमाणक पंजीकृत नहीं है — आपातकालीन पहुच हेतु मेरी प्रोफ़ाइल में पंजीकृत करें।"
    },
    "invalidId": {
      "title": "अमान्य रोगी ID",
      "body": "प्रदान की गई रोगी ID मान्य नहीं है।",
      "action": "रोगी खोजें"
    },
    "notFound": {
      "title": "रोगी नहीं मिला",
      "body": "रोगी डेटा लोड नहीं किया जा सका। रोगी मौजूद नहीं हो सकता है या आपके पास एक्सेस नहीं हो सकता है।",
      "action": "रोगी खोजें"
    },
    "loadError": {
      "title": "रोगी चार्ट लोड करने में विफल",
      "body": "चार्ट लोड नहीं हो सका। कृपया पुनः प्रयास करें।",
      "action": "पुनः प्रयास"
    }
  },
  "address": {
    "title": "पते",
    "addAddress": "पता जोड़ें",
    "newTitle": "नया पता",
    "editTitle": "पता संपादित करें",
    "loading": "पते लोड हो रहे हैं...",
    "loadError": "पता जानकारी लोड करने में विफल।",
    "empty": "कोई पता दर्ज नहीं।",
    "addressType": {
      "label": "प्रकार",
      "values": {
        "home": "घर",
        "work": "कार्यस्थल",
        "temporary": "अस्थायी",
        "billing": "बिलिंग"
      }
    },
    "fields": {
      "addressLine1": "पता पंक्ति 1",
      "addressLine2": "पता पंक्ति 2",
      "addressLine3": "पता पंक्ति 3",
      "district": "ज़िला",
      "city": "शहर",
      "stateProvince": "राज्य",
      "postalCode": "पिन कोड",
      "country": "देश"
    },
    "placeholders": {
      "addressLine1": "सड़क का पता",
      "addressLine2": "अपार्टमेंट, इकाई, मंज़िल",
      "addressLine3": "इमारत, ब्लॉक",
      "district": "ज़िला/तहसील",
      "postalCode": "जैसे 110001",
      "country": "जैसे IN"
    },
    "primaryBadge": "मुख्य",
    "setPrimary": "मुख्य पता के रूप में सेट करें",
    "primaryHelper": "(अन्य पते मुख्य के रूप में अनसेट हो जाएंगे)",
    "fromLabel": "से: {{date}}",
    "toLabel": "तक: {{date}}",
    "save": "सहेजें",
    "update": "अद्यतन करें",
    "cancel": "रद्द करें",
    "editTooltip": "पता संपादित करें",
    "removeTooltip": "पता हटाएँ",
    "addedSuccess": "पता जोड़ा गया",
    "addError": "पता जोड़ने में विफल",
    "updatedSuccess": "पता अद्यतन किया गया",
    "updateError": "पता अद्यतन करने में विफल",
    "removedSuccess": "पता हटा दिया गया",
    "removeError": "पता हटाने में विफल",
    "requiredError": "पता पंक्ति 1 और देश आवश्यक हैं",
    "confirmRemoveTitle": "पता हटाएँ",
    "confirmRemoveMessage": "क्या आप वाकई यह {{type}} पता हटाना चाहते हैं?",
    "confirmRemoveLabel": "हटाएँ"
  },
  "allergies": {
    "pageTitle": "एलर्जी",
    "addAllergy": "एलर्जी जोड़ें",
    "loading": "एलर्जी लोड हो रही है...",
    "loadError": "एलर्जी जानकारी लोड करने में विफल।",
    "nka": {
      "title": "कोई ज्ञात एलर्जी नहीं (NKA)",
      "body": "इस रोगी के लिए कोई एलर्जी दस्तावेज़ीकृत नहीं की गई है।"
    },
    "sections": {
      "active": "सक्रिय एलर्जी ({{count}})",
      "inactive": "निष्क्रिय एलर्जी ({{count}})"
    },
    "fields": {
      "reaction": "प्रतिक्रिया",
      "severity": "गंभीरता",
      "onset": "आरंभ",
      "recorded": "दर्ज दिनांक"
    },
    "inactiveSummary": "प्रतिक्रिया: {{reaction}} | गंभीरता: {{severity}}",
    "deactivate": "निष्क्रिय करें",
    "deactivateTooltip": "एलर्जी निष्क्रिय करें",
    "deleteTooltip": "एलर्जी हटाएँ",
    "deactivatedSuccess": "एलर्जी निष्क्रिय की गई",
    "deactivateError": "एलर्जी निष्क्रिय करने में विफल",
    "removedSuccess": "एलर्जी हटाई गई",
    "removeError": "एलर्जी हटाने में विफल",
    "confirmDeactivateTitle": "निष्क्रिय करने की पुष्टि",
    "confirmDeactivateMessage": "क्या आप वाकई \"{{name}}\" को निष्क्रिय करना चाहते हैं?",
    "confirmDeleteTitle": "हटाने की पुष्टि",
    "confirmDeleteMessage": "क्या आप वाकई \"{{name}}\" को स्थायी रूप से हटाना चाहते हैं?",
    "confirmLabel": "पुष्टि करें"
  },
  "problems": {
    "pageTitle": "समस्या सूची",
    "addProblem": "समस्या जोड़ें",
    "loading": "समस्या सूची लोड हो रही है...",
    "loadError": "समस्या सूची लोड करने में विफल।",
    "tabs": {
      "active": "सक्रिय ({{count}})",
      "resolvedInactive": "समाधानित / निष्क्रिय ({{count}})"
    },
    "sortByLabel": "इसके अनुसार क्रमबद्ध करें:",
    "sortBy": {
      "onsetDate": "आरंभ तिथि",
      "severity": "गंभीरता"
    },
    "status": {
      "label": "स्थिति",
      "values": {
        "active": "सक्रिय",
        "resolved": "समाधानित",
        "inactive": "निष्क्रिय"
      }
    },
    "empty": {
      "active": "कोई सक्रिय समस्या दर्ज नहीं।",
      "resolved": "कोई समाधानित या निष्क्रिय समस्या नहीं।"
    },
    "fields": {
      "onset": "आरंभ",
      "resolved": "समाधान"
    },
    "resolveButton": "समाधानित करें",
    "reactivateButton": "पुनः सक्रिय करें",
    "resolveTooltip": "समाधानित के रूप में चिह्नित करें",
    "reactivateTooltip": "पुनः सक्रिय करें",
    "statusUpdatedSuccess": "समस्या स्थिति अद्यतन की गई",
    "statusUpdateError": "समस्या स्थिति अद्यतन करने में विफल"
  },
  "immunizations": {
    "pageTitle": "टीकाकरण",
    "addImmunization": "टीकाकरण जोड़ें",
    "loading": "टीकाकरण रिकॉर्ड लोड हो रहे हैं...",
    "loadError": "टीकाकरण रिकॉर्ड लोड करने में विफल।",
    "empty": "कोई टीकाकरण रिकॉर्ड नहीं मिला।",
    "dueOverdue": "देय / अतिदेय टीकाकरण ({{count}})",
    "upcoming": "आगामी टीकाकरण ({{count}})",
    "dueLabel": "देय: {{date}}",
    "fromDateLabel": "तिथि से",
    "toDateLabel": "तिथि तक",
    "fromDateAria": "टीकाकरण आरंभ तिथि",
    "toDateAria": "टीकाकरण अंतिम तिथि",
    "clearFilters": "साफ़ करें",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "टीका",
      "date": "तिथि",
      "lotNumber": "लॉट संख्या",
      "site": "स्थान",
      "administeredBy": "लगाने वाले",
      "nextDue": "अगली देय",
      "status": "स्थिति"
    },
    "dueStatus": {
      "label": "स्थिति",
      "values": {
        "overdue": "अतिदेय",
        "dueToday": "आज देय",
        "upcoming": "आगामी"
      }
    }
  },
  "contacts": {
    "pageTitle": "संपर्क",
    "addContact": "संपर्क जोड़ें",
    "loading": "संपर्क लोड हो रहे हैं...",
    "loadError": "संपर्क जानकारी लोड करने में विफल।",
    "empty": "कोई संपर्क दर्ज नहीं।",
    "emergencyBadge": "आपातकालीन",
    "sections": {
      "emergency": "आपातकालीन संपर्क ({{count}})",
      "other": "अन्य संपर्क ({{count}})"
    },
    "editTooltip": "संपर्क संपादित करें",
    "deleteTooltip": "संपर्क हटाएँ",
    "deletedSuccess": "संपर्क हटाया गया",
    "deleteError": "संपर्क हटाने में विफल",
    "confirmDeleteTitle": "संपर्क हटाएँ",
    "confirmDeleteMessage": "क्या आप वाकई \"{{name}}\" को हटाना चाहते हैं?",
    "confirmDeleteLabel": "हटाएँ"
  },
  "insurances": {
    "pageTitle": "बीमा",
    "addInsurance": "बीमा जोड़ें",
    "loading": "बीमा जानकारी लोड हो रही है...",
    "loadError": "बीमा जानकारी लोड करने में विफल।",
    "empty": {
      "title": "कोई बीमा योजना नहीं",
      "body": "इस रोगी के लिए कोई बीमा योजना दर्ज नहीं की गई है।"
    },
    "sections": {
      "active": "सक्रिय योजनाएँ ({{count}})",
      "inactive": "निष्क्रिय योजनाएँ ({{count}})"
    },
    "status": {
      "label": "स्थिति",
      "values": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "pendingVerification": "सत्यापन लंबित"
      }
    },
    "fields": {
      "memberId": "सदस्य ID",
      "groupNumber": "समूह संख्या",
      "effectiveDate": "प्रभावी तिथि",
      "terminationDate": "समाप्ति तिथि",
      "copay": "सह-भुगतान",
      "coinsurance": "सह-बीमा",
      "deductible": "कटौती योग्य",
      "subscriber": "धारक"
    },
    "preAuthBadge": "पूर्व-प्राधिकरण आवश्यक",
    "lastVerifiedLabel": "अंतिम सत्यापित: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "सत्यापित करें",
    "verifyTooltip": "पात्रता सत्यापित करें",
    "editButton": "संपादित करें",
    "verifySuccess": "पात्रता सत्यापन आरंभ किया गया",
    "verifyError": "पात्रता सत्यापन विफल"
  },
  "identifiersTab": {
    "pageTitle": "पहचानकर्ता",
    "addIdentifier": "पहचानकर्ता जोड़ें",
    "loading": "पहचानकर्ता लोड हो रहे हैं...",
    "loadError": "पहचानकर्ता जानकारी लोड करने में विफल।",
    "empty": "कोई पहचानकर्ता दर्ज नहीं।",
    "newTitle": "नया पहचानकर्ता",
    "type": {
      "label": "प्रकार",
      "selectPlaceholder": "प्रकार चुनें...",
      "values": {
        "externalMrn": "बाहरी MRN",
        "insuranceId": "बीमा ID",
        "studyId": "अध्ययन ID",
        "healthCard": "स्वास्थ्य कार्ड",
        "nationalRegistry": "राष्ट्रीय रजिस्ट्री",
        "passport": "पासपोर्ट",
        "driverLicense": "ड्राइविंग लाइसेंस",
        "other": "अन्य"
      }
    },
    "fields": {
      "value": "मान",
      "assigningAuthority": "जारीकर्ता प्राधिकरण",
      "effectiveDate": "प्रभावी तिथि",
      "expiryDate": "समाप्ति तिथि"
    },
    "placeholders": {
      "value": "जैसे 2341 2341 2346",
      "assigningAuthority": "जैसे UIDAI"
    },
    "status": {
      "label": "स्थिति",
      "values": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      }
    },
    "columns": {
      "type": "प्रकार",
      "value": "मान",
      "assigningAuthority": "जारीकर्ता प्राधिकरण",
      "effectiveDate": "प्रभावी तिथि",
      "expiryDate": "समाप्ति तिथि",
      "status": "स्थिति",
      "actions": "क्रियाएँ"
    },
    "save": "सहेजें",
    "cancel": "रद्द करें",
    "removeTooltip": "पहचानकर्ता हटाएँ",
    "addedSuccess": "पहचानकर्ता जोड़ा गया",
    "addError": "पहचानकर्ता जोड़ने में विफल",
    "removedSuccess": "पहचानकर्ता हटाया गया",
    "removeError": "पहचानकर्ता हटाने में विफल",
    "requiredError": "प्रकार और मान आवश्यक हैं",
    "confirmRemoveTitle": "पहचानकर्ता हटाएँ",
    "confirmRemoveMessage": "क्या आप वाकई \"{{type}}: {{value}}\" को हटाना चाहते हैं?",
    "confirmRemoveLabel": "हटाएँ"
  },
  "pages": {
    "advanceDirectives": {
      "title": "अग्रिम चिकित्सा निर्देश",
      "addButton": "निर्देश जोड़ें",
      "emptyState": "इस रोगी के लिए कोई अग्रिम चिकित्सा निर्देश दर्ज नहीं है।",
      "loading": "अग्रिम चिकित्सा निर्देश लोड हो रहे हैं...",
      "loadError": "अग्रिम चिकित्सा निर्देश लोड करने में विफल।",
      "documentLink": "दस्तावेज़ देखें",
      "effectivePrefix": "प्रभावी:",
      "reviewPrefix": "समीक्षा:",
      "form": {
        "title": "नया अग्रिम चिकित्सा निर्देश",
        "labels": {
          "directiveType": "निर्देश प्रकार",
          "status": "स्थिति",
          "effectiveDate": "प्रभावी तिथि",
          "notes": "टिप्पणियाँ",
          "optional": "वैकल्पिक"
        },
        "placeholders": {
          "notes": "निर्देश के बारे में अतिरिक्त टिप्पणियाँ..."
        },
        "selectTypePlaceholder": "प्रकार चुनें...",
        "aria": {
          "effectiveDate": "प्रभावी तिथि"
        },
        "buttons": {
          "save": "निर्देश सहेजें",
          "cancel": "रद्द करें"
        }
      },
      "directiveType": {
        "DNR": "पुनर्जीवित न करें (DNR)",
        "living-will": "जीवनकालीन वसीयत",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "स्वास्थ्य देखभाल प्रतिनिधि",
        "power-of-attorney": "स्थायी मुख्तारनामा"
      },
      "directiveStatus": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "revoked": "निरस्त",
        "pending": "समीक्षा लंबित"
      },
      "toast": {
        "added": "अग्रिम चिकित्सा निर्देश जोड़ा गया",
        "addFailed": "अग्रिम चिकित्सा निर्देश जोड़ने में विफल",
        "directiveTypeRequired": "निर्देश प्रकार आवश्यक है"
      }
    },
    "familyHistory": {
      "title": "पारिवारिक इतिहास",
      "addButton": "प्रविष्टि जोड़ें",
      "emptyState": "इस रोगी के लिए कोई पारिवारिक इतिहास दर्ज नहीं है।",
      "loading": "पारिवारिक इतिहास लोड हो रहा है...",
      "loadError": "पारिवारिक इतिहास लोड करने में विफल।",
      "onsetAge": "शुरुआत की उम्र: {{age}} वर्ष",
      "outcomePrefix": "परिणाम:",
      "form": {
        "title": "नई पारिवारिक इतिहास प्रविष्टि",
        "labels": {
          "relationship": "रिश्ता",
          "conditionName": "रोग का नाम",
          "conditionCode": "रोग कोड",
          "onsetAge": "शुरुआत की उम्र",
          "outcome": "परिणाम",
          "optional": "वैकल्पिक"
        },
        "placeholders": {
          "onsetAge": "वर्षों में आयु"
        },
        "selectRelationshipPlaceholder": "रिश्ता चुनें...",
        "selectOutcomePlaceholder": "परिणाम चुनें...",
        "buttons": {
          "save": "प्रविष्टि सहेजें",
          "cancel": "रद्द करें"
        }
      },
      "relationship": {
        "Mother": "माता",
        "Father": "पिता",
        "Sibling": "भाई-बहन",
        "Maternal Grandmother": "नानी",
        "Maternal Grandfather": "नाना",
        "Paternal Grandmother": "दादी",
        "Paternal Grandfather": "दादा",
        "Child": "संतान",
        "Aunt": "मौसी/बुआ/चाची/मामी",
        "Uncle": "मामा/चाचा/ताऊ/फूफा"
      },
      "outcome": {
        "alive": "जीवित",
        "deceased": "मृत",
        "unknown": "अज्ञात"
      },
      "toast": {
        "added": "पारिवारिक इतिहास प्रविष्टि जोड़ी गई",
        "addFailed": "पारिवारिक इतिहास प्रविष्टि जोड़ने में विफल",
        "relationshipAndConditionRequired": "रिश्ता और रोग का नाम आवश्यक हैं"
      }
    },
    "socialHistory": {
      "title": "सामाजिक इतिहास",
      "editButton": "संपादित करें",
      "loading": "सामाजिक इतिहास लोड हो रहा है...",
      "loadError": "सामाजिक इतिहास लोड करने में विफल।",
      "labels": {
        "smokingStatus": "धूम्रपान स्थिति",
        "alcoholUse": "शराब का उपयोग",
        "substanceUse": "पदार्थ का उपयोग",
        "housing": "आवास",
        "employment": "रोजगार",
        "safetyScreening": "सुरक्षा स्क्रीनिंग",
        "notes": "टिप्पणियाँ"
      },
      "placeholders": {
        "notes": "अतिरिक्त टिप्पणियाँ..."
      },
      "buttons": {
        "save": "परिवर्तन सहेजें",
        "cancel": "रद्द करें"
      },
      "toast": {
        "updated": "सामाजिक इतिहास अद्यतन किया गया",
        "updateFailed": "सामाजिक इतिहास अद्यतन करने में विफल"
      },
      "smokingStatus": {
        "never": "कभी धूम्रपान नहीं किया",
        "former": "पूर्व धूम्रपान करने वाला",
        "currentDaily": "वर्तमान दैनिक धूम्रपान करने वाला",
        "currentOccasional": "वर्तमान अवसरीय धूम्रपान करने वाला",
        "unknown": "अज्ञात"
      },
      "alcoholUse": {
        "None": "कोई नहीं",
        "Social/Occasional": "सामाजिक/अवसरीय",
        "Moderate": "मध्यम",
        "Heavy": "भारी",
        "In Recovery": "पुनर्प्राप्ति में",
        "Unknown": "अज्ञात"
      },
      "substanceUse": {
        "None": "कोई नहीं",
        "Current Use": "वर्तमान उपयोग",
        "Former Use": "पूर्व उपयोग",
        "In Treatment": "उपचाराधीन",
        "Unknown": "अज्ञात"
      },
      "housing": {
        "Stable": "स्थिर",
        "Unstable": "अस्थिर",
        "Homeless": "बेघर",
        "Assisted Living": "सहायक जीवनशैली",
        "Nursing Facility": "नर्सिंग सुविधा",
        "Unknown": "अज्ञात"
      },
      "employment": {
        "Employed Full-Time": "पूर्णकालिक नियोजित",
        "Employed Part-Time": "अंशकालिक नियोजित",
        "Self-Employed": "स्व-नियोजित",
        "Unemployed": "बेरोजगार",
        "Retired": "सेवानिवृत्त",
        "Student": "छात्र",
        "Disabled": "दिव्यांग",
        "Unknown": "अज्ञात"
      },
      "safetyScreening": {
        "No Concerns": "कोई चिंता नहीं",
        "Concerns Identified": "चिंताएँ पहचानी गईं",
        "Declined to Answer": "उत्तर देने से इनकार",
        "Not Screened": "स्क्रीन नहीं की गई"
      }
    },
    "surgicalHistory": {
      "title": "शल्य चिकित्सा इतिहास",
      "addButton": "प्रक्रिया जोड़ें",
      "emptyState": "इस रोगी के लिए कोई शल्य चिकित्सा इतिहास दर्ज नहीं है।",
      "loading": "शल्य चिकित्सा इतिहास लोड हो रहा है...",
      "loadError": "शल्य चिकित्सा इतिहास लोड करने में विफल।",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "दिनांक: {{date}}",
      "surgeonLabel": "सर्जन: {{name}}",
      "anesthesiaLabel": "एनेस्थीसिया: {{type}}",
      "outcomePrefix": "परिणाम:",
      "complicationsPrefix": "जटिलताएँ:",
      "form": {
        "title": "नई शल्य चिकित्सा इतिहास प्रविष्टि",
        "labels": {
          "procedureName": "प्रक्रिया का नाम",
          "procedureCode": "प्रक्रिया कोड",
          "procedureCodeSuffix": "(CPT)",
          "date": "दिनांक",
          "surgeonName": "सर्जन का नाम",
          "anesthesiaType": "एनेस्थीसिया प्रकार",
          "laterality": "पक्ष",
          "outcome": "परिणाम",
          "complications": "जटिलताएँ"
        },
        "placeholders": {
          "surgeonName": "सर्जन का नाम",
          "complications": "कोई जटिलताएँ हों तो..."
        },
        "selectPlaceholder": "चुनें...",
        "aria": {
          "procedureDate": "प्रक्रिया की तिथि"
        },
        "buttons": {
          "save": "प्रविष्टि सहेजें",
          "cancel": "रद्द करें"
        }
      },
      "anesthesiaType": {
        "general": "सामान्य एनेस्थीसिया",
        "regional": "क्षेत्रीय एनेस्थीसिया",
        "local": "स्थानीय एनेस्थीसिया",
        "spinal": "स्पाइनल एनेस्थीसिया",
        "epidural": "एपिड्यूरल एनेस्थीसिया",
        "sedation": "बेहोशी (सेडेशन)",
        "none": "कोई नहीं",
        "unknown": "अज्ञात"
      },
      "laterality": {
        "left": "बायाँ",
        "right": "दायाँ",
        "bilateral": "दोनों ओर"
      },
      "toast": {
        "added": "शल्य चिकित्सा इतिहास प्रविष्टि जोड़ी गई",
        "addFailed": "शल्य चिकित्सा इतिहास प्रविष्टि जोड़ने में विफल",
        "procedureNameRequired": "प्रक्रिया का नाम आवश्यक है"
      }
    },
    "referralManagement": {
      "title": "रेफ़रल",
      "addButton": "नया रेफ़रल",
      "refresh": "रिफ़्रेश",
      "loading": "रेफ़रल लोड हो रहे हैं...",
      "errorState": "रेफ़रल लोड करने में विफल।",
      "emptyState": "इस रोगी के लिए कोई रेफ़रल नहीं है।",
      "emptyStateFiltered": "चयनित स्थिति से मेल खाने वाले कोई रेफ़रल नहीं हैं।",
      "ariaFilterStatus": "स्थिति के अनुसार रेफ़रल फ़िल्टर करें",
      "externalBadge": "बाह्य",
      "filterStatus": {
        "allLabel": "सभी स्थितियाँ"
      },
      "table": {
        "type": "प्रकार",
        "reason": "कारण",
        "specialty": "विशेषज्ञता",
        "priority": "प्राथमिकता",
        "status": "स्थिति",
        "requested": "अनुरोध तिथि",
        "target": "लक्ष्य तिथि"
      },
      "form": {
        "title": "नया रेफ़रल",
        "labels": {
          "referralType": "रेफ़रल प्रकार",
          "priority": "प्राथमिकता",
          "specialty": "विशेषज्ञता",
          "reason": "कारण",
          "targetDate": "लक्ष्य तिथि",
          "clinicalNotes": "नैदानिक नोट्स",
          "optional": "वैकल्पिक"
        },
        "placeholders": {
          "reason": "रेफ़रल का कारण",
          "clinicalNotes": "अतिरिक्त नैदानिक नोट्स..."
        },
        "selectReferralTypePlaceholder": "प्रकार चुनें...",
        "selectSpecialtyPlaceholder": "विशेषज्ञता चुनें...",
        "buttons": {
          "create": "रेफ़रल बनाएँ",
          "cancel": "रद्द करें"
        }
      },
      "referralType": {
        "consultation": "परामर्श",
        "transfer": "देखभाल स्थानांतरण",
        "second-opinion": "दूसरी राय",
        "diagnostic": "नैदानिक",
        "therapeutic": "उपचारात्मक"
      },
      "priority": {
        "routine": "सामान्य",
        "urgent": "तत्काल",
        "stat": "STAT"
      },
      "status": {
        "draft": "मसौदा",
        "submitted": "सबमिट किया गया",
        "accepted": "स्वीकृत",
        "scheduled": "निर्धारित",
        "completed": "पूरा हुआ",
        "cancelled": "रद्द किया गया"
      },
      "toasts": {
        "createSuccess": "रेफ़रल बनाया गया",
        "createFailed": "रेफ़रल बनाने में विफल",
        "validationFailed": "रेफ़रल प्रकार और कारण आवश्यक हैं"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "{{count}} जोड़ी में ऐसा रोगी है जिसे आप नहीं देख सकते",
      "title_other": "{{count}} जोड़ियों में ऐसे रोगी हैं जिन्हें आप नहीं देख सकते",
      "body": "आपके किसी रोगी का रिकॉर्ड किसी अन्य सुविधा के रिकॉर्ड से दोहरा हो सकता है। यह जोड़ी सूची में नहीं है क्योंकि इसका निर्णय करने के लिए आपकी पहुँच से बाहर के रोगी को देखना होगा — स्वास्थ्य सूचना प्रबंधन से समीक्षा कराएँ।"
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "रिकॉर्ड निर्यात करें",
    "exporting": "निर्यात हो रहा है…",
    "success": "रिकॉर्ड निर्यात किया गया",
    "failed": "निर्यात विफल — कुछ भी डाउनलोड नहीं हुआ",
    "tooltip": "इस रोगी का संपूर्ण रिकॉर्ड एक पोर्टेबल फ़ाइल के रूप में डाउनलोड करें"
  },
  "device": {
    "addTitle": "प्रत्यारोपण युक्ति दर्ज करें",
    "editTitle": "निकासी दर्ज करें",
    "deviceName": "युक्ति का नाम",
    "deviceNamePlaceholder": "जैसे, Evera MRI ICD, ड्रग-एल्यूटिंग स्टेंट",
    "deviceNameTooLong": "युक्ति का नाम 512 वर्णों से अधिक नहीं होना चाहिए",
    "deviceType": "युक्ति का प्रकार",
    "deviceTypePlaceholder": "जैसे, पेसमेकर, स्टेंट, कृत्रिम अंग",
    "udi": "UDI",
    "udiPlaceholder": "अद्वितीय युक्ति पहचान वाहक",
    "deviceCode": "युक्ति कोड",
    "deviceCodeSystem": "कोड प्रणाली",
    "deviceCodeSystemPlaceholder": "जैसे, GMDN, SNOMED CT",
    "manufacturer": "निर्माता",
    "modelNumber": "मॉडल",
    "lotNumber": "लॉट संख्या",
    "serialNumber": "क्रम संख्या",
    "implantDate": "प्रत्यारोपण तिथि",
    "explantDate": "निकासी तिथि",
    "status": "स्थिति",
    "statusOptions": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "explanted": "निकाला गया"
    },
    "mriSafety": "MRI सुरक्षा",
    "mriSafetyOptions": {
      "safe": "सुरक्षित",
      "conditional": "सशर्त",
      "unsafe": "असुरक्षित",
      "unknown": "अज्ञात"
    },
    "notes": "टिप्पणियाँ",
    "notesPlaceholder": "अतिरिक्त टिप्पणियाँ...",
    "savedSuccess": "युक्ति सफलतापूर्वक दर्ज की गई",
    "saveError": "युक्ति दर्ज करने में विफल",
    "updatedSuccess": "निकासी सफलतापूर्वक दर्ज की गई",
    "updateError": "निकासी दर्ज करने में विफल",
    "explantRequiresDate": "निकाली गई युक्ति के लिए निकासी तिथि आवश्यक है",
    "explantBeforeImplant": "निकासी तिथि प्रत्यारोपण तिथि से पहले नहीं हो सकती"
  },
  "devices": {
    "pageTitle": "प्रत्यारोपण युक्तियाँ",
    "addDevice": "युक्ति दर्ज करें",
    "loading": "युक्तियाँ लोड हो रही हैं...",
    "loadError": "युक्ति जानकारी लोड करने में विफल।",
    "empty": {
      "title": "कोई प्रत्यारोपण युक्ति नहीं",
      "body": "इस रोगी के लिए कोई युक्ति दर्ज नहीं की गई है।"
    },
    "sections": {
      "active": "सक्रिय युक्तियाँ ({{count}})",
      "history": "निकाली गई / निष्क्रिय ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "निर्माता",
      "implanted": "प्रत्यारोपण",
      "explanted": "निकासी",
      "mriSafety": "MRI सुरक्षा",
      "recorded": "दर्ज"
    },
    "recordExplant": "निकासी दर्ज करें",
    "explantTooltip": "इस युक्ति की निकासी दर्ज करें",
    "removeTooltip": "प्रविष्टि हटाएँ",
    "removedSuccess": "युक्ति प्रविष्टि हटाई गई",
    "removeError": "युक्ति प्रविष्टि हटाने में विफल",
    "confirmDeleteTitle": "हटाने की पुष्टि करें",
    "confirmDeleteMessage": "क्या सूची से \"{{name}}\" हटाएँ? केवल गलती से दर्ज प्रविष्टियाँ हटाएँ — शरीर से निकासी दर्ज करने के लिए निकासी दर्ज करें का उपयोग करें।",
    "confirmLabel": "पुष्टि करें"
  },
  "ccdaImports": {
    "title": "C-CDA आयात",
    "subtitle": "मिलान हेतु प्राप्त दस्तावेज़। आयात खोलकर प्रत्येक प्रविष्टि की समीक्षा कर चार्ट में जोड़ें।",
    "empty": "इस रोगी के लिए कोई आयातित दस्तावेज़ नहीं है।",
    "loadError": "आयात लोड नहीं हो सके।",
    "received": "प्राप्त",
    "docType": "प्रकार",
    "status": "स्थिति",
    "pending": "लंबित",
    "entries": "प्रविष्टियाँ",
    "match": "मेल",
    "mismatch": "ID मेल नहीं",
    "statuses": {
      "pending": "लंबित",
      "reviewed": "समीक्षित",
      "dismissed": "छोड़ा गया"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "रेफरल नोट",
      "discharge-summary": "डिस्चार्ज सारांश",
      "other": "अन्य"
    }
  },
  "ccdaReview": {
    "title": "आयात #{{id}}",
    "back": "आयात सूची पर वापस जाएं",
    "loadError": "यह आयात लोड नहीं हो सका।",
    "mismatchWarning": "प्रेषक पहचान इस रोगी से मेल नहीं खाती। स्वीकार करने से पहले दस्तावेज़ का स्वामित्व सत्यापित करें।",
    "unnamed": "अनाम प्रविष्टि",
    "accept": "स्वीकारें",
    "reject": "अस्वीकारें",
    "accepted": "प्रविष्टि चार्ट में मिला दी गई",
    "rejected": "प्रविष्टि अस्वीकृत",
    "alreadyReviewed": "किसी अन्य ने समीक्षा कर दी है — नीचे ताज़ा किया गया",
    "reviewError": "समीक्षा विफल",
    "confirmAcceptTitle": "चार्ट में स्वीकारें?",
    "confirmAcceptMessage": "“{{name}}” इस रोगी के चार्ट में जोड़ा जाएगा।",
    "confirmRejectTitle": "यह प्रविष्टि अस्वीकारें?",
    "confirmRejectMessage": "“{{name}}” कतार से हटा दी जाएगी। मूल दस्तावेज़ फ़ाइल में रहेगा।",
    "sections": {
      "problem": "समस्याएं",
      "medication": "दवाएं",
      "allergy": "एलर्जी"
    },
    "statuses": {
      "accepted": "स्वीकृत",
      "rejected": "अस्वीकृत"
    }
  }
}
